import React from 'react';
import dateFormat from 'dateformat';
import { Typography } from '@mui/material';

export default function AdvertisedInError(props) {
  return (
    <React.Fragment>
      <div>
        <Typography variant='subtitle2' display='inline'>
          PERMITTEE:
        </Typography>
        <span>{` ${props.permit.PERMITTEE}`}</span>
      </div>
      <div>
        <Typography variant='subtitle2' display='inline'>
          DATE OF HEARING:
        </Typography>
        <span>
          {` ${dateFormat(props.permit.HEARING_DATE, 'mmmm d, yyyy', true)}`}
        </span>
      </div>
    </React.Fragment>
  );
}
